const MAX_REASONS_SHOWN = 3;

const extractErrorMessage = (error) => {
    const detail = error?.response?.data?.detail;
    if (typeof detail === "string" && detail) return detail;
    if (error?.response?.status === 403) return "无权限";
    if (!error?.response) return "网络异常";
    return error?.response?.data?.message || error?.message || "未知错误";
};

/**
 * 逐条执行启停并汇总结果。单条请求静默（不弹全局提示），由调用方统一展示一条汇总。
 * @returns {Promise<{ succeededIds: string[], failedIds: string[], reasons: string[] }>}
 */
export const runBatchStatusChange = async (ids, requestFn) => {
    const results = await Promise.allSettled(ids.map((id) => requestFn(id, { _silentError: true })));

    const succeededIds = [];
    const failedIds = [];
    const reasonSet = new Set();
    results.forEach((result, index) => {
        if (result.status === "fulfilled") {
            succeededIds.push(ids[index]);
        } else {
            failedIds.push(ids[index]);
            reasonSet.add(extractErrorMessage(result.reason));
        }
    });

    return { succeededIds, failedIds, reasons: Array.from(reasonSet).slice(0, MAX_REASONS_SHOWN) };
};
